// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ApproverUserDetailFragmentDoc } from '../../../../fragments/circularFragments.generated';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApprovalSubject_ChangeEventFragment = { __typename?: 'ChangeEvent', id: string, name: string, displayName: string, internalNote?: string | null | undefined, title: string, status: Types.ChangeEventStatus, originalTotalCostInCents: number, originalTotalPriceInCents: number, proposedTotalCostInCents: number, proposedTotalPriceInCents: number, budgetImpactInCents: number, reason: { __typename?: 'ChangeEventReason', id: string, code: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string }, approval?: { __typename?: 'Approval', id: string } | null | undefined, predictedApprovers: Array<
    | { __typename?: 'Client', id: string, name: string }
    | { __typename?: 'InternalUser', id: string, avatar: string, name: string }
    | { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }
  >, project:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  , impactedTrades: Array<{ __typename?: 'TradePartner', id: string, name: string }>, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string, fullCode: string } } }>, tradesToDraftCommitmentsFor: Array<{ __typename?: 'TradePartner', id: string, name: string }> };

export type ApprovalChangeEventQueryVariables = Types.Exact<{
  changeEventIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ApprovalChangeEventQuery = { __typename?: 'Query', changeEvents: Array<{ __typename?: 'ChangeEvent', id: string, name: string, displayName: string, internalNote?: string | null | undefined, title: string, status: Types.ChangeEventStatus, originalTotalCostInCents: number, originalTotalPriceInCents: number, proposedTotalCostInCents: number, proposedTotalPriceInCents: number, budgetImpactInCents: number, reason: { __typename?: 'ChangeEventReason', id: string, code: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string }, approval?: { __typename?: 'Approval', id: string } | null | undefined, predictedApprovers: Array<
      | { __typename?: 'Client', id: string, name: string }
      | { __typename?: 'InternalUser', id: string, avatar: string, name: string }
      | { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }
    >, project:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    , impactedTrades: Array<{ __typename?: 'TradePartner', id: string, name: string }>, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string, fullCode: string } } }>, tradesToDraftCommitmentsFor: Array<{ __typename?: 'TradePartner', id: string, name: string }> }> };

export type SaveApprovalChangeEventMutationVariables = Types.Exact<{
  input: Types.SaveChangeEventInput;
}>;


export type SaveApprovalChangeEventMutation = { __typename?: 'Mutation', saveChangeEvent: { __typename?: 'SaveChangeEventResult', changeEvent: { __typename?: 'ChangeEvent', id: string, name: string, displayName: string, internalNote?: string | null | undefined, title: string, status: Types.ChangeEventStatus, originalTotalCostInCents: number, originalTotalPriceInCents: number, proposedTotalCostInCents: number, proposedTotalPriceInCents: number, budgetImpactInCents: number, reason: { __typename?: 'ChangeEventReason', id: string, code: string, name: string }, blueprintUrl: { __typename?: 'Url', path: string }, approval?: { __typename?: 'Approval', id: string } | null | undefined, predictedApprovers: Array<
        | { __typename?: 'Client', id: string, name: string }
        | { __typename?: 'InternalUser', id: string, avatar: string, name: string }
        | { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }
      >, project:
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      , impactedTrades: Array<{ __typename?: 'TradePartner', id: string, name: string }>, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string, fullCode: string } } }>, tradesToDraftCommitmentsFor: Array<{ __typename?: 'TradePartner', id: string, name: string }> } } };

export const ApprovalSubject_ChangeEventFragmentDoc = gql`
    fragment ApprovalSubject_ChangeEvent on ChangeEvent {
  id
  name
  displayName
  internalNote
  title
  reason {
    id
    code
    name
  }
  blueprintUrl {
    path
  }
  status
  approval {
    id
  }
  predictedApprovers {
    ...ApproverUserDetail
  }
  originalTotalCostInCents
  originalTotalPriceInCents
  proposedTotalCostInCents
  proposedTotalPriceInCents
  budgetImpactInCents
  project {
    ...Named
  }
  impactedTrades {
    id
    name
  }
  lineItems {
    id
    projectItem {
      id
      item {
        id
        fullCode
      }
    }
  }
  tradesToDraftCommitmentsFor {
    id
    name
  }
}
    ${ApproverUserDetailFragmentDoc}
${NamedFragmentDoc}`;
export const ApprovalChangeEventDocument = gql`
    query ApprovalChangeEvent($changeEventIds: [ID!]!) {
  changeEvents(filter: {id: $changeEventIds}) {
    ...ApprovalSubject_ChangeEvent
  }
}
    ${ApprovalSubject_ChangeEventFragmentDoc}`;

/**
 * __useApprovalChangeEventQuery__
 *
 * To run a query within a React component, call `useApprovalChangeEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalChangeEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalChangeEventQuery({
 *   variables: {
 *      changeEventIds: // value for 'changeEventIds'
 *   },
 * });
 */
export function useApprovalChangeEventQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApprovalChangeEventQuery, ApprovalChangeEventQueryVariables> & ({ variables: ApprovalChangeEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApprovalChangeEventQuery, ApprovalChangeEventQueryVariables>(ApprovalChangeEventDocument, options);
      }
export function useApprovalChangeEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApprovalChangeEventQuery, ApprovalChangeEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApprovalChangeEventQuery, ApprovalChangeEventQueryVariables>(ApprovalChangeEventDocument, options);
        }
// @ts-ignore
export function useApprovalChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApprovalChangeEventQuery, ApprovalChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApprovalChangeEventQuery, ApprovalChangeEventQueryVariables>;
export function useApprovalChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApprovalChangeEventQuery, ApprovalChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApprovalChangeEventQuery | undefined, ApprovalChangeEventQueryVariables>;
export function useApprovalChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApprovalChangeEventQuery, ApprovalChangeEventQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApprovalChangeEventQuery, ApprovalChangeEventQueryVariables>(ApprovalChangeEventDocument, options);
        }
export type ApprovalChangeEventQueryHookResult = ReturnType<typeof useApprovalChangeEventQuery>;
export type ApprovalChangeEventLazyQueryHookResult = ReturnType<typeof useApprovalChangeEventLazyQuery>;
export type ApprovalChangeEventSuspenseQueryHookResult = ReturnType<typeof useApprovalChangeEventSuspenseQuery>;
export type ApprovalChangeEventQueryResult = ApolloReactCommon.QueryResult<ApprovalChangeEventQuery, ApprovalChangeEventQueryVariables>;
export const SaveApprovalChangeEventDocument = gql`
    mutation SaveApprovalChangeEvent($input: SaveChangeEventInput!) {
  saveChangeEvent(input: $input) {
    changeEvent {
      ...ApprovalSubject_ChangeEvent
    }
  }
}
    ${ApprovalSubject_ChangeEventFragmentDoc}`;

/**
 * __useSaveApprovalChangeEventMutation__
 *
 * To run a mutation, you first call `useSaveApprovalChangeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveApprovalChangeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveApprovalChangeEventMutation, { data, loading, error }] = useSaveApprovalChangeEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveApprovalChangeEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveApprovalChangeEventMutation, SaveApprovalChangeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveApprovalChangeEventMutation, SaveApprovalChangeEventMutationVariables>(SaveApprovalChangeEventDocument, options);
      }
export type SaveApprovalChangeEventMutationHookResult = ReturnType<typeof useSaveApprovalChangeEventMutation>;
export type SaveApprovalChangeEventMutationResult = ApolloReactCommon.MutationResult<SaveApprovalChangeEventMutation>;